class ProductQuickAdd extends HTMLElement {
  constructor() {
    super();    
    this.toggleVisibility(this)
    this.updateVariant(this)   
  }
 
  toggleVisibility(quickAddToCart){
    var footerY =  document.querySelector('.shopify-section-group-group-footer').clientHeight;
    var minHeight = 1400;
    var productInfo = document.querySelector('.product-section');
    if (productInfo != null) { minHeight = productInfo.offsetHeight }
    var indexSection = document.querySelector('.template-index .brick__section');
    if (indexSection != null) { minHeight = indexSection.offsetHeight + indexSection.getBoundingClientRect().top }
    document.addEventListener('scroll', function() {
      setTimeout(() => {
        if (minHeight < 1400 && indexSection != null) { minHeight = indexSection.offsetHeight + indexSection.getBoundingClientRect().top }
      }, 100);
      let documentHeight = document.body.scrollHeight;
      let currentScroll = window.scrollY + window.innerHeight;

      if (window.scrollY >= minHeight && currentScroll + footerY < documentHeight) {
        quickAddToCart.classList.add("is-visible")
      } else { 
        quickAddToCart.classList.remove("is-visible")
      }
    })  
  }

  updateVariant(quickAddToCart) {
    const productJSON = quickAddToCart.querySelector('[data-product-json]');
    if (productJSON && productJSON.innerHTML !== '') {
      quickAddToCart.product = JSON.parse(productJSON.innerHTML);
    }

    var options = this.querySelectorAll('.radio__fieldset input')
    options.forEach(option => {
      option.addEventListener("click", function(event){
        if (document.querySelector('.product-section input[value="' + event.target.getAttribute("value") + '"]') != null){
          document.querySelector('.product-section input[value="' + event.target.getAttribute("value") + '"]').click();
        }

        quickAddToCart.product.variants.forEach((variant) => {
          if (variant.title == event.target.getAttribute("value")){
            quickAddToCart.updatePrice(quickAddToCart, variant)
            quickAddToCart.updateId(quickAddToCart, variant)
            quickAddToCart.updateImage(quickAddToCart, variant)
          }
        });

        return false
      })
    })
  }

  updatePrice(quickAddToCart, variant){
    let price = variant.price;
    quickAddToCart.querySelector('[data-button-price]').innerHTML = themeVendor.themeCurrency.formatMoney(price, theme.moneyFormat)
  }

  updateId(quickAddToCart, variant){
    quickAddToCart.querySelector('[name="id"]').value = variant.id
  }

  updateImage(quickAddToCart, variant){
    quickAddToCart.querySelector('img').setAttribute('src', variant.featured_image.src)
    const srcset = variant.featured_image.src.concat('&width=80 80w,' + variant.featured_image.src.concat('&width=160 160w,'))
    quickAddToCart.querySelector('img').setAttribute('srcset', srcset)
  }
}

customElements.define("product-quick-add", ProductQuickAdd);